import React from "react";
import { Link } from "react-router-dom";

export function Hero({
  title,
  subtitle,
  eyebrow = "För skolklasser och idrottslag",
  primaryCtaLabel = "Registrera er grupp",
  primaryCtaTo = "/register-group",
  secondaryCtaLabel = "Se hur det fungerar",
  secondaryCtaHref = "/sa-fungerar-salespartner",
}) {
  return (
    <section className="relative overflow-hidden bg-slate-950 text-white">
      <picture className="absolute inset-0" aria-hidden="true">
        <source type="image/avif" media="(max-width: 640px)" srcSet="/hero-640.avif 640w" sizes="100vw" />
        <source type="image/avif" srcSet="/hero-1376.avif 1376w" sizes="100vw" />
        <source type="image/webp" media="(max-width: 640px)" srcSet="/hero-640.webp 640w" sizes="100vw" />
        <source type="image/webp" srcSet="/hero-1376.webp 1376w" sizes="100vw" />
        <img src="/hero-1376.jpg" alt="" width="1376" height="768" fetchpriority="high" decoding="async" className="absolute inset-0 h-full w-full object-cover object-[70%_center] sm:object-center" />
      </picture>
      <div aria-hidden="true" className="absolute inset-0 bg-[linear-gradient(90deg,rgba(8,18,40,0.96)_0%,rgba(8,18,40,0.82)_52%,rgba(8,18,40,0.45)_100%)]" />
      <div className="relative mx-auto flex min-h-[620px] max-w-7xl items-center px-4 py-20 sm:px-6 md:min-h-[680px] lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-amber-300">
            {eyebrow}
          </p>
          <h1 className="mt-5 text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/85 sm:text-xl">
            {subtitle}
          </p>

          <ul className="mt-7 grid gap-3 text-base font-medium text-white/90 sm:grid-cols-2">
            <li className="flex gap-3">
              <span aria-hidden="true" className="text-amber-300">●</span>
              Personliga säljlänkar och QR-koder
            </li>
            <li className="flex gap-3">
              <span aria-hidden="true" className="text-amber-300">●</span>
              Direktleverans eller gruppleverans
            </li>
          </ul>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <div className="w-full sm:w-auto">
              <Link
                to={primaryCtaTo}
                className="inline-flex w-full items-center justify-center rounded-xl bg-amber-500 px-6 py-4 font-bold text-slate-950 shadow-lg shadow-amber-500/15 transition hover:bg-amber-400 motion-safe:hover:-translate-y-0.5 motion-safe:hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-300 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 sm:w-auto"
              >
                {primaryCtaLabel}
              </Link>
            </div>
            <div className="w-full sm:w-auto">
              <Link
                to={secondaryCtaHref}
                className="inline-flex w-full items-center justify-center rounded-xl border border-white/40 bg-white/5 px-6 py-4 font-bold text-white transition hover:bg-white/10 motion-safe:hover:-translate-y-0.5 motion-safe:hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 sm:w-auto"
              >
                {secondaryCtaLabel}
              </Link>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/65">
            Registreringen är en ansökan som behöver godkännas innan onboarding och försäljning.
          </p>
        </div>
      </div>
    </section>
  );
}

export default function MarketingHome() {
  return (
    <Hero
      title="Samla pengar till laget eller klassen med SalesPartner"
      subtitle="Registrera gruppen, bjud in säljare och dela personliga länkar. Beställningar och leveransalternativ samlas i ett digitalt flöde."
    />
  );
}
